'use client';

import { useEffect, useState, type ComponentType } from 'react';

/**
 * Lädt die Single-Page-App nur im Browser.
 *
 * Nur im Browser ist in Phase 1 der Migration Absicht: Die App greift beim Laden
 * ihrer Module auf `window`, `document` und `localStorage` zu und war nie für
 * den Server gebaut.
 *
 * **Bewusst nicht `next/dynamic(…, { ssr: false })`.** Das legt eine
 * Suspense-Grenze um die App, und React 19 hält das Einblenden dahinter bis zu
 * 300 ms zurück (gemessen im paperball.ai-Piloten: ~315 ms statt ~25 ms). Ein
 * eigenes `import()` im Effekt hat keine Grenze und damit keine Wartezeit.
 */
export default function SpaHuelle() {
  const [App, setApp] = useState<ComponentType | null>(null);
  const [fehler, setFehler] = useState<unknown>(null);

  useEffect(() => {
    import('../../../src/ClientApp').then(
      (modul) => setApp(() => modul.default),
      // Ein Bündel, das nicht lädt (Deploy während des Besuchs, Netz weg),
      // darf nicht als leere Seite enden: Beim Rendern geworfen, landet der
      // Fehler in der Fehlerseite von Next statt nirgends (Regel #7).
      (err: unknown) => setFehler(err),
    );
  }, []);

  if (fehler) throw fehler;
  return App ? <App /> : null;
}
